import { chatHistoryUrl } from "./history";
import { forgetPendingTurn, readPendingTurn, rememberPendingTurn, } from "./pending-turn";
import { TrainerSocket, } from "./trainer-socket";
/** A socket that never opens, never delivers and never needs closing. */
function inertSocket() {
    return {
        close: () => undefined,
        onclose: null,
        onerror: null,
        onmessage: null,
        onopen: null,
        send: () => undefined,
    };
}
export function openConversationSocket(options) {
    const { conversationId, pendingTurnStore, transcriptCache } = options;
    let live = true;
    const trainer = new TrainerSocket({
        aiBaseUrl: () => options.aiBaseUrl,
        ...(options.appActive === undefined
            ? {}
            : { appActive: options.appActive }),
        buyTicket: options.buyTicket,
        conversationId,
        ...(options.subjectAccountId === undefined
            ? {}
            : { subjectAccountId: options.subjectAccountId }),
        // One ticket per read, bought the same way the socket buys its own — the
        // history route is on the agent Worker and authenticates with a ticket,
        // not with the access token (`D34`).
        loadHistory: async () => {
            const { ticket } = await options.buyTicket();
            return await options.fetchHistory(chatHistoryUrl(options.aiBaseUrl, ticket, conversationId));
        },
        onChange: (snapshot) => {
            if (live) {
                options.onChange(conversationId, snapshot);
            }
        },
        ...(options.online === undefined ? {} : { online: options.online }),
        openSocket: (url) => (live ? options.openSocket(url) : inertSocket()),
        pendingTurn: {
            forget: () => forgetPendingTurn(conversationId, pendingTurnStore),
            read: () => readPendingTurn(conversationId, options.now(), pendingTurnStore),
            remember: (requestId, outbound) => rememberPendingTurn(conversationId, requestId, options.now(), pendingTurnStore, outbound),
        },
        ...(transcriptCache === undefined
            ? {}
            : {
                transcriptCache: {
                    forget: () => {
                        if (live) {
                            transcriptCache.forget(conversationId);
                        }
                    },
                    read: () => transcriptCache.read(conversationId),
                    write: (messages) => {
                        if (live) {
                            transcriptCache.write(conversationId, messages);
                        }
                    },
                },
            }),
    });
    return {
        close: () => {
            live = false;
            trainer.dispose();
        },
        trainer,
    };
}
//# sourceMappingURL=conversation-socket.js.map